import React, { Component } from 'react';
import { Card, CardBody } from 'reactstrap';
import { UAH } from '../../filters';

export default class StatisticsWidget extends Component {
  render() {
    return (
      <Card className="statistics-card">
        <CardBody>
          <div>Ожидаемая прибыль: <b>{UAH(3500)}</b></div>
          <div>Всего заработано: <b>{UAH(87300)}</b></div>

          <div style={{ fontSize: '.9rem', marginTop: '8px' }}><a className="text-dark" href="">Еще...</a></div>
        </CardBody>
      </Card>
    );
  }
}
